export default __webpack_public_path__ + "static/media/homescreen.0409e7c1.png";